// Le QR imprime sur chaque etiquette encode desormais l'URL de CETTE appli
// (https://verif.sip.bicadev.com/?token=...), pas l'URL de l'API directement :
// un scan avec l'appareil photo natif d'un telephone doit pouvoir ouvrir la page
// et verifier tout seul, sans passer par le scanner interne de cette appli. Ca
// veut dire que cette appli doit connaitre l'hote de l'API pour appeler
// elle-meme le endpoint de verification une fois le token extrait.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app.bicadev.com';

// Accepte soit le texte scanne par la camera (une URL complete, celle de cette
// appli ou, pour compatibilite avec d'anciennes etiquettes, celle de l'API), soit
// directement un token deja extrait (ex: depuis window.location.search au
// chargement de la page). Retourne le token brut, ou null si rien d'exploitable.
export function extraireToken(texteOuUrl) {
  if (!texteOuUrl) {
    return null;
  }
  try {
    const url = new URL(texteOuUrl, window.location.origin);
    const parametre = url.searchParams.get('token');
    if (parametre) {
      return parametre;
    }
    // Compat anciennes etiquettes : QR pointant directement vers
    // .../api/public/verification/carton/{token}.
    const segments = url.pathname.split('/').filter(Boolean);
    const index = segments.indexOf('carton');
    if (index !== -1 && segments[index + 1]) {
      return segments[index + 1];
    }
    return null;
  } catch (e) {
    // Pas une URL : on suppose que c'est deja un token brut.
    return texteOuUrl.trim() || null;
  }
}

export async function verifierCarton(token) {
  const url = `${API_BASE_URL}/api/public/verification/carton/${encodeURIComponent(token)}`;

  const reponse = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (reponse.status === 404) {
    throw new Error("Ce carton n'a pas pu etre verifie (code invalide, altere, ou perime).");
  }
  if (!reponse.ok) {
    throw new Error(`Erreur serveur (${reponse.status}). Reessayez dans un instant.`);
  }

  return reponse.json();
}
